import { useState } from 'react';
import { motion } from 'framer-motion';
import { OutputSidebar } from './output-sidebar';
import { OutputContent } from './output-content';
import { OutputControls } from './output-controls';

export function OutputPage() {
  const [activeTab, setActiveTab] = useState('notes');

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="grid gap-8 lg:grid-cols-[300px_1fr]"
        >
          <OutputSidebar />
          <div className="space-y-6">
            <OutputControls activeTab={activeTab} onTabChange={setActiveTab} />
            <OutputContent activeTab={activeTab} />
          </div>
        </motion.div>
      </div>
    </div>
  );
}